import React, { FunctionComponent, useState } from "react";

import {
  Button,
  Flex,
  Modal,
  TextField,
  SelectField,
  Option,
} from "coral-ui/components/v2";
import styles from "./TagCommentModal.css";

interface Props {
  open: boolean;
  commentTagLabel?: {
    FEATURED: string | null;
    QA: string | null;
  } | null;
  onClose: () => void;
  onSubmit: (tag: string, label: string) => void;
}

const TagCommentModal: FunctionComponent<Props> = ({
  open,
  commentTagLabel,
  onClose,
  onSubmit,
}) => {
  const [selectedTag, setSelectedTag] = useState<string>("FEATURED");
  const [label, setLabel] = useState<string>("");

  const tagOptions = [
    { value: "FEATURED", label: "Featured" },
    { value: "QA", label: "Q&A" },
  ];

  const handleSubmit = () => {
    if (selectedTag) {
      onSubmit(selectedTag, label.trim());
      setSelectedTag("");
      setLabel("");
      onClose();
    }
  };

  const handleClose = () => {
    setSelectedTag("");
    setLabel("");
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className={styles.container}>
        <h3 className={styles.title}>Pin Comment</h3>
        <>
          <Flex direction="column" spacing={3}>
            <SelectField
              value={selectedTag}
              onChange={(e) => {
                setSelectedTag(e.target.value);
              }}
            >
              {tagOptions.map((tag) => (
                <Option key={tag.label} value={tag.value}>
                  {tag.label}
                </Option>
              ))}
            </SelectField>
            <p className={styles.description}>
              {selectedTag === "FEATURED"
                ? `The Featured comment will be displayed with title '${
                    commentTagLabel?.FEATURED || "Featured by"
                  }'. Do you want to change it?`
                : `The Q&A comment will be displayed with title '${
                    commentTagLabel?.QA || "Q&A"
                  }'. Do you want to change it?`}
            </p>
            <TextField
              value={label}
              onChange={(e) => {
                setLabel(e.target.value);
              }}
              placeholder="Enter custom label..."
            />

            <Flex justifyContent="flex-end" spacing={2}>
              <Button variant="outlined" onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant="regular"
                onClick={handleSubmit}
                disabled={!selectedTag.trim()}
              >
                Submit
              </Button>
            </Flex>
          </Flex>
        </>
      </div>
    </Modal>
  );
};

export default TagCommentModal;
